import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./style.scss";
import fetchGraphQLErrors from "helpers/fetchGraphqlErrors";
import { snackbarError, snackbarSuccess } from "shared/redux/actions/Snackbar";
import { useDispatch } from "react-redux";


export default function TemplateItem({ item }) {

    const [t] = useTranslation();

    const dispatch = useDispatch();



    return (
        <Link to={`/templates/template/${item.bookId}/info`}>
            <div className="organisation-list-item">
                <div className="organisation-list-item-rows">
                    <div className="organisation-list-item-row">
                        <div className="organisation-list-item-column">
                            <div className="item is-bold is-center">
                                {item.bookName}
                            </div>
                        </div>
                    </div>
                    <div className="organisation-list-item-row">
                        <div className="organisation-list-item-column">
                            <div className="label">
                                {t("organisation.branch.plural")}
                            </div>
                            <div className={`item approval-status 
                                    ${item.approvalStatus === "APPROVED" ? "approved"
                                    : item.approvalStatus === "REJECTED" ? "rejected"
                                    : item.approvalStatus === "PENDING" || item.approvalStatus === "CANCELED" ? "neutral"
                                    : ""}`}>
                                {item.approvalStatus}
                            </div>
                        </div>
                    </div>
                    <div className="organisation-list-item-row">
                        <div className="organisation-list-item-column">
                            <div className="label">
                                {t("organisation.user.plural")}
                            </div>
                            <div className="item">
                                {item.approvalMessage}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Link>);

}

TemplateItem.propTypes = {
    item: PropTypes.object.isRequired
};

